import './DetectedApplications.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityApplicationStatus } from '@sonar-software/sonar-core';
import { DetectedApplicationCard } from './DetectedApplicationCard';
import empty from 'images/empty-detected-apps.svg';
import { SonarCard } from '@ui/general';
import { SonarText } from '@ui/text';
import { Checkbox, Col, Row, Space } from 'antd';
import { Else, If, Then } from 'react-if';
import React, { useMemo } from 'react';
import { useBoolean, useDataSecurityApps } from '@hooks';
export const DetectedApplications = () => {
    const applications = useDataSecurityApps(false, true, true);
    const [showHidden, setShowHidden] = useBoolean(false);
    const appsToShow = useMemo(() => {
        var _a;
        return (_a = applications.filter((app) => app.status === DataSecurityApplicationStatus.Detected ||
            (showHidden && app.status === DataSecurityApplicationStatus.Deleted)).map((app) => app.applicationId)) !== null && _a !== void 0 ? _a : [];
    }, [applications, showHidden]);
    return (React.createElement(SonarCard, { className: classNames('detected-applications', { empty: appsToShow.length === 0 }), extra: React.createElement(Checkbox, { checked: showHidden, id: 'show-hidden-checkbox', onChange: setShowHidden.toggle }, COPY_SPECIFIC.SHOW_HIDDEN_APPLICATIONS), title: COPY_SPECIFIC.DETECTED_APPLICATIONS, titleClassName: 'h2' },
        React.createElement(If, { condition: appsToShow.length },
            React.createElement(Then, null,
                React.createElement(Row, { className: 'detected-applications-list' }, appsToShow.map((id) => React.createElement(Col, { key: id },
                    React.createElement(DetectedApplicationCard, { applicationId: id }))))),
            React.createElement(Else, null,
                React.createElement(Space, { direction: 'vertical', size: 'large' },
                    React.createElement(SonarText, { size: 16, weight: 'semibold' }, COPY_SPECIFIC.ALL_APPS_MONITORED),
                    React.createElement("img", { alt: COPY_SPECIFIC.ALL_APPS_MONITORED, className: 'empty-apps', src: empty }))))));
};
